import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from '@/functions/Util';
import Message from '@/models/Message';

export default class CrmAgendaValidation extends DefaultValidation {
    validate(root, agenda, refs, selected) {
        let validated = true;
        let timeValidated = true;

        if (isNull(agenda.crmAgenda.titulo)) {
            // console.log("isNull(agenda.crmAgenda.titulo)")
            refs.nomeInput.focusedOut = true;
            validated = false;
        }

        if (selected.tipoAgendaSelected == null) {
            // console.log("selected.tipoAgendaSelected == null")
            refs.tipoAgendaListInput.focusedOut = true;
            validated = false;
        }

        if (selected.colaboradorSelected.length == 0) {
            // console.log("selected.colaboradorSelected.length == 0")
            refs.colaboradorSelect.focusedOut = true;
            validated = false;
        }

        if (isNull(selected.datainicial)) {
            // console.log("isNull(selected.datainicial)")
            refs.datainicialSelect.focusedOut = true;
            validated = false;
        }

        if (isNull(selected.horaInicio.HH) || isNull(selected.horaInicio.mm)) {
            // console.log("isNull(selected.horaInicio.HH) || isNull(selected.horaInicio.mm)")
            refs.horaInicioSelect.focusedOut = true;
            validated = false;
        }

        if (isNull(selected.horaFim.HH) || isNull(selected.horaFim.mm)) {
            // console.log("isNull(selected.horaFim.HH) || isNull(selected.horaFim.mm)")
            refs.horaFimSelect.focusedOut = true;
            validated = false;
        }

        if (
            !isNull(selected.horaInicio.HH) &&
            !isNull(selected.horaInicio.mm) &&
            !isNull(selected.horaFim.HH) &&
            !isNull(selected.horaFim.mm)
        ) {
            let tempInicio = selected.horaInicio.HH + ':' + selected.horaInicio.mm + ':00';

            let tempFim = selected.horaFim.HH + ':' + selected.horaFim.mm + ':00';
            timeValidated = tempInicio < tempFim;
        }

        if ([1, 2, 3].includes(selected.repeticaoSelected.id)) {
            // console.log("[1, 2, 3].includes(selected.repeticaoSelected.id)")
            if (selected.diasSemanaSelected.length == 0) {
                // console.log("selected.diasSemanaSelected.length == 0")
                refs.diaSemanaSelect.focusedOut = true;
                validated = false;
            }
            if (selected.terminaPorSelected.id == 0 && isNull(selected.datafinal)) {
                // console.log("selected.terminaPorSelected.id == 0 && isNull(selected.datafinal)")
                refs.datafinalSelect.focusedOut = true;
                validated = false;
            } else if (
                selected.terminaPorSelected.id == 1 &&
                agenda.crmAgenda.repeticao_qtd_ocorrencias < 2
            ) {
                // console.log("selected.terminaPorSelected.id == 1 && agenda.crmAgenda.repeticao_qtd_ocorrencias < 2")
                refs.repeticao_qtd_ocorrenciasNumber.focusedOut = true;
                validated = false;
            }
        }

        if (!timeValidated) {
            // root.showMessage('alert', 'msg-erro-horarios-invalidos', true);
            root.msgs.push(new Message('alert', 'msg-erro-horarios-invalidos', true));
        }
        if (!validated) {
            // root.showMessage('alert', 'msg-campos-obrigatorios', true);
            root.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        return validated && timeValidated;
    }
}
